import { baseDropDownContainerStyle, baseDropDownTextStyle } from './Base'

export const dropDownContainerStyle = baseDropDownContainerStyle

export const dropDownTextStyle = baseDropDownTextStyle
